"use client";
import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Link from "next/link";
import { motion } from "framer-motion";
import "./Articles.css";
import Image from "next/image";

function Articles({ recentBlogs = [], blogspage }) {
  if (!recentBlogs.length) return null;

  return (
    <div
      className={`bg_article_gray header-padding-top ${
        blogspage === "blogs" ? "blogs-page-wrapper" : ""
      }`}
      id={blogspage === "blogs" ? "blogs-page" : ""}
    >
      <section className=" section-paddinglarge bg_article_gray">
        <div className="main-container-fluid">
          <div className="inner-flex inner-flex-medium">
            <div className="flex-row alc j-c-sb">
              <motion.div
                className=" section-title64 "
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                viewport={{ once: true }}
              >
                <h2 className="uppder-case">Articles</h2>
              </motion.div>

              {blogspage != "blogs" && (
                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  <Link href="/blogs" className="hide-mobile-only">
                    <button className="reecosys-template-button button-style-primary-outline">
                      <p>View All</p>
                    </button>
                  </Link>
                </motion.div>
              )}
            </div>

            {/* Desktop */}
            {/* Desktop */}
            <div
              className={`horizontal articles_detailes inner-flex-small ${
                blogspage !== "blogs" ? "desktop-articles" : ""
              }`}
            >
              {recentBlogs.map((item, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 60 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.7, delay: i * 0.12 }}
                  viewport={{ once: true, amount: 0.15 }}
                  style={{ flexBasis: "calc(100% / 3)" }}
                >
                  <Link href={`/blogs/${item.slug}`}>
                    <div className="sec11-img-content inner-flex inner-flex-small">
                      <div className="sec11-img">
                        <motion.div
                          className="blog-img relative"
                          style={{
                            aspectRatio: "460 / 460",
                            background: "#dedede",
                          }}
                        >
                          <Image
                            src={
                              item?.image_full
                                ? `${item.image_full}&w=800&h=800&q=100`
                                : "/images/fallback-image.jpg"
                            }
                            alt={item.title || "Blog Image"}
                            fill
                            loading="lazy"
                          />
                        </motion.div>
                      </div>

                      <div className="inner-flex inner-flex-smallest">
                        <div className="section-content">
                          <p className="small-text">{item.published_date}</p>
                        </div>

                        <div className="section-subtitle blogs-title">
                          <h4 className="semibold-fonts">{item.title}</h4>
                        </div>
                      </div>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>

            {/* Mobile Swiper only for homepage */}
            {blogspage !== "blogs" && (
              <div className="mobile-articles-slider">
                <Swiper
                  modules={[Pagination]}
                  slidesPerView={1}
                  spaceBetween={20}
                  pagination={{ clickable: true }}
                >
                  {recentBlogs.map((item, i) => (
                    <SwiperSlide key={i}>
                      <Link href={`/blogs/${item.slug}`}>
                        <div className="sec11-img-content inner-flex inner-flex-small">
                          <div className="sec11-img">
                            <div
                              className="blog-img relative"
                              style={{
                                aspectRatio: "460 / 460",
                                background: "#dedede",
                              }}
                            >
                              <Image
                                src={
                                  item?.image_full
                                    ? `${item.image_full}&w=800&h=800&q=100`
                                    : "/images/fallback-image.jpg"
                                }
                                alt={item.title || "Blog Image"}
                                fill
                                loading="lazy"
                              />
                            </div>
                          </div>

                          <div className="inner-flex inner-flex-smallest">
                            <div className="section-content">
                              <p className="small-text">
                                {item.published_date}
                              </p>
                            </div>

                            <div className="section-subtitle blogs-title">
                              <h4 className="semibold-fonts">{item.title}</h4>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}

            {blogspage != "blogs" && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <Link
                  href="/blogs"
                  className="visible-mobile-only"
                  style={{ marginTop: "2rem" }}
                >
                  <button className="reecosys-template-button button-style-primary-outline w100">
                    <p>View All</p>
                  </button>
                </Link>
              </motion.div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Articles;
